import { securedAxiosAPI } from 'utils/axios';

export const pricingListApi = async (payload) => {
    const res = await securedAxiosAPI.post('/costing-analysis/cost-log', payload.payload);
    return res.data;
};

export const filtersDropdownApi = async () => {
    const res = await securedAxiosAPI.get('/costing-analysis/drop-down-cost-log');
    return res.data[0];
};
